// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_SP_footer__36sgW","content":"Footer_SP_content__1JhKK"};